import { Component, OnChanges, Input } from '@angular/core';
import { SmallshiService } from '../../services/smallshi.service';

@Component({
  selector: 'app-oops',
  templateUrl: './oops.component.html'
})
export class OopsComponent implements OnChanges {

  constructor(private small: SmallshiService) {
  }

 ngOnChanges(){
 }
redirect(){
  window.location.href = this.small.urlRetorno;
}
}
